module.exports = __webpack_public_path__ + "img/personal-web08.c47f2789.png";